<template>
    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
        <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <img src="@/assets/children2.jpg" class="img-fluid formBanner" alt="Event Registration Banner">
    <div class="container outerContainer col-md-6 isForm">
        <div class="container innerContainer">
            
            <!-- Form -->
            <p id="eventFormHeader">BE AN EVENT PARTICIPANT</p>
            <form class="row g-3" @submit="submitForm">

                <!-- Full Name -->
                <div class="col-md-6">
                    <label for="inputFullName" class="form-label">Full Name</label>
                    <input type="text" class="form-control" id="inputFullName" placeholder="Full Name"
                        v-model="visitorFormData.fullName" @input="visitorForm$.fullName.$touch">
                    <div v-if="visitorForm$.fullName.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ visitorForm$.fullName.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Email -->
                <div class="col-md-6">
                    <label for="inputEmailAddress" class="form-label">E-mail Address</label>
                    <input type="email" class="form-control" id="inputEmailAddress" placeholder="E-mail Address"
                        v-model="visitorFormData.email" @input="visitorForm$.email.$touch">
                    <div v-if="visitorForm$.email.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ visitorForm$.email.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Contact Number -->
                <div class="col-md-6">
                    <label for="inputContactNumber" class="form-label">Contact Number</label>
                    <input type="text" class="form-control" id="inputContactNumber" placeholder="Contact Number"
                        v-model="visitorFormData.contactNumber" @input="visitorForm$.contactNumber.$touch">
                    <div v-if="visitorForm$.contactNumber.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ visitorForm$.contactNumber.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Category -->
                <div class="col-md-6">
                    <label for="selectEventCategory" class="form-label">Category</label>
                    <select class="form-select" id="selectEventCategory" v-model="visitorFormData.category"
                        @input="visitorForm$.category.$touch">
                        <option v-if="events.length == 0" value="" selected disabled hidden>No available events</option>
                        <option v-else value="" selected disabled hidden>Choose here</option>
                        <option v-for="event in events" :key="event.id"
                            :selected="event.id === visitorFormData.category ? true : false" :value="event.Category">
                            {{ event.Category }}
                        </option>
                    </select>
                    <div v-if="visitorForm$.category.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ visitorForm$.category.$errors[0].$message }}</em>
                    </div>
                </div>
            </form>
        </div>
        <button id="registerButton" @click="submitForm">Register</button>
    </div>
</template>

<script>
// Dependencies
import { collection, onSnapshot, query, orderBy, where, addDoc, serverTimestamp, doc, getDocs } from "firebase/firestore";
import { db } from "@/firebase";
import { onMounted, ref, onUnmounted, reactive } from 'vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core';
import { required, helpers, email, maxLength } from '@vuelidate/validators';

export default {
    setup() {
        const router = useRouter();
        const route = useRoute();

        let unsubscribeCategory;
        // Form Data
        const visitorFormData = reactive({
            fullName: "",
            email: "",
            contactNumber: "",
            category: "",
        })

        // Check if user chose a category beforehand
        const getEventCategory = async (eventId) => {
            if (!eventId) {
                return
            }
            unsubscribeCategory = onSnapshot(doc(db, "Events", eventId), (doc) => {
                visitorFormData.category = doc.exists() ? doc.data().Category : "";
            });
        }


        const loading = ref(false);

        // Regex for contact number
        const validContactNumber = (contactNumber) => {
            const regex = /^[0][9][0-9]{9}$/;
            return regex.test(contactNumber);
        }

        const visitorFormRules = {
            fullName: { required, maxLength: maxLength(300) },
            email: { required, email, maxLength: maxLength(254) },
            contactNumber: { required, validContactNumber: helpers.withMessage("Invalid Contact Number (Example: 09123456789)", validContactNumber) },
            category: { required }
        }

        const visitorForm$ = useVuelidate(visitorFormRules, visitorFormData);
        // Submitting of Form
        const submitForm = async () => {

            let eventAppliedId;
            const eventDB = collection(db, 'Events');
            const q = query(eventDB, where('Category', '==', visitorFormData.category), where('IsArchived', '==', false));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                eventAppliedId = doc.id;
                return;
            });

            loading.value = true;
            // Check if form is valid/filled up
            const result = await visitorForm$.value.$validate();

            if (!result) {
                alert("Please check the form for errors");
                loading.value = false;
                return
            }

            // Submit form to database
            const colRef = collection(db, "Event Registrations")
            await addDoc(colRef, {
                Name: visitorFormData.fullName,
                Email: visitorFormData.email,
                ContactNumber: visitorFormData.contactNumber,
                CreationTimestamp: serverTimestamp(),
                EventRegisteredId: eventAppliedId,
                IsArchived: false,
            });

            //Alert Successful Registration
            alert("Successfully Registered!");
            loading.value = false;

            //Redirect user
            router.push('/')
        }


        // Getting of Data
        const eventId = computed(() => route.params.id);

        getEventCategory(eventId.value);

        const events = ref([]);
        let unsubscribe;

        onMounted(() => {
            // Query to get available upcoming events
            const eventsCollection = collection(db, 'Events');
            const q = query(eventsCollection, where("IsOpen", "==", true), orderBy('StartTime', "desc"));
            unsubscribe = onSnapshot(q, (snapshot) => {
                events.value = snapshot.docs.map((doc) => {
                    const selected = doc.id == eventId.value ? true : false;
                    return { id: doc.id, ...doc.data(), selected: selected }
                })
            });
        });

        onUnmounted(() => {
            unsubscribeCategory();
            unsubscribe();
        });

        return { events, loading, visitorFormData, visitorForm$, submitForm }

    },
}
</script>


<style scoped src="@/assets/css/globalStyle.css"></style>
